module.exports = __webpack_public_path__ + "img/icon_site_search.c5becd07.png";